import _ from 'lodash';
import isInGroup from '../../services/util/isInGroup';

import debug from '../../services/debug';
import {
  SET_CONTACT_REQUESTED,
  SET_CONTACT_ABORTED,
  SET_CONTACT_COMPLETED,
  SET_CONTACT_FAILED,
} from './types';

const setContactAction = () => (dispatch, getState) => {
  const { session, contacts } = getState();
  const sessionData = session.get('data');
  if (!isInGroup(sessionData, 'Admin') && !isInGroup(sessionData, 'Adviser')) {
    const contact = contacts.get('set');

    if (!_.isEmpty(contact)) {
      dispatch({
        type: SET_CONTACT_ABORTED,
      });

      return;
    }
  }

  dispatch({
    type: SET_CONTACT_REQUESTED,
  });

  try {
    dispatch({
      type: SET_CONTACT_COMPLETED,
      payload: {
        ContactID: 0,
      },
    });
  } catch (err) {
    debug(SET_CONTACT_FAILED, err);

    dispatch({
      type: SET_CONTACT_FAILED,
      payload: err,
    });
  }
};

export default setContactAction;
